import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';

import App from './components/App';

// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')||"/";
// const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter >
      <App />
    </BrowserRouter>
  </Provider>,
);
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
// // import { createBrowserHistory } from 'history';
// import configureStore from './store/configureStore';

// import App from './components/App';

// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// // const history = createBrowserHistory({ basename: baseUrl });
// const store = configureStore();

// ReactDOM.render(
//   <Provider store={store}>
//     <BrowserRouter >
//       <App />
//     </BrowserRouter>
//   </Provider>,
//   document.getElementById('root'));
